module.exports = __webpack_public_path__ + "574b2c3e4a3a7fc6c1c3c82ef7408fe1.png";